import React, { useEffect, useState } from "react";
import ToolbarHeader from "../../components/ToolbarHeader";
import CustomButton from "../../components/CustomButton";
import CustomTable from "../../components/CustomTable";
import { useNavigate } from "react-router-dom";
import { icons } from "../../assets/icons";
import InputWithIcon from "../../components/FormFields/InputWithIcon";
import { usersChildListColumns, usersListColumns } from "../../components/Columns/Users";
import useApi from "../../hooks/useApi";
import { apiUrls } from "../../utils/api/apiUrls";
import { toast } from "react-toastify";
import CustomModal from "../../components/CustomModal/CustomModal";
import { userChildDumm } from "./userChildDummy";

const Users = () => {
  const { data = [], apiCall } = useApi();
  const { data: data1, apiCall: deleteUser } = useApi();
  const navigate = useNavigate();

  useEffect(() => {
    getUsersCall()
  }, []);

  const getUsersCall = () => {
    apiCall({
      url: apiUrls.sso.getUsers,
      method: "get",
    });
  }
  
  const onClickCreate = () => {
    navigate("/users/create");
  };

  const editUsers = (value) => {
    navigate("/users/create", {state: value})
  }

  const deleteUserCall = (id) => {
    deleteUser({
      url: apiUrls.sso.deleteUser + id,
      method: "delete",
      onSuccess: () => {
        toast.success("User Deleted successfully");
        getUsersCall()
      },
    });
  }

  const [isUserModalOpen, setUserModalOpen] = useState(false)
  const [userModalData, setUserModalData] = useState()

  // const goToUsersWithVid = (vid) => {
  //   // Navigate to the /users/:vid route with the specified vid value
  //   navigate(`/users/${vid}`);
  // };
  const userLabelHandler = value => {
    console.log("user label handler", value)
    setUserModalData(value)
    setUserModalOpen(true)
    // goToUsersWithVid(value.id)
  }

  const closeUserLabelHandler = value => {
    console.log("user label handler", value)
    setUserModalOpen(false)
  }
  
  return (
    <div className="dashboard-container">
      <ToolbarHeader
        title="Users"
        showBack={false}
        containerClassName="mt-14"
        renderRight={() => {
          // return (
          //   <CustomButton
          //     title="Add User"
          //     wrapperClassName="border-[1px] !border-[var(--blackColor)] !bg-transparent !px-5"
          //     textClassName="text-[var(--blackColor)] pl-2"
          //     onClick={onClickCreate}
          //     icon={icons.plusBlackIcon}
          //   />
          // );
        }}
      />

      <div className="bg-[var(--whiteColor)] rounded-[1rem] min-h-[10rem] mt-10 flex flex-col justify-center px-4 py-6 gap-y-5">
        <CustomTable
          isGlobalSearchEnable
          renderTools={() => {
            return (
              <InputWithIcon
                placeholder="Search"
                containerClassName="search-input-wrapper"
                inputClassName="font-size-small"
                rightIcon={icons.searchIcon}
              />
            );
          }}
          data={data}
          // data={userChildDumm}
          columns={usersListColumns(
            deleteUserCall, true, editUsers, userLabelHandler
          )}
          showPageSizeChange
          centerAlignedColumns={["groups"]}
        />
      </div>
      {userModalData?.name && <CustomModal isModalVisible={isUserModalOpen} onRequestClose={closeUserLabelHandler} children={<div>
        <div>
          <button onClick={() => {navigate(-1)}}>Go Back</button>
          <div><CustomTable columns={usersChildListColumns(
            deleteUserCall, true, editUsers, userLabelHandler
          )} data={userModalData?.children}/></div>
          <span>{userModalData?.name}</span>
          <span>{userModalData?.roleName}</span>
          <span>{userModalData?.username}</span>
          <span>{userModalData?.ownerUsername}</span>
          <span>{userModalData?.mobile}</span>
        </div>
      </div>}/>}
    </div>
  );
};

export default Users;
